import React from 'react';
import { Button, DialogActions, Typography } from '@material-ui/core';
import { useMutation } from 'react-query';
import { deleteObjectiveKPI } from '../../../api/objective/objectiveKPI.api';
import { useTranslation } from 'react-i18next';

const DeleteKPI = ({
  kpi,
  objective,
  onSubmitSuccess,
  onCancel
}) => {
  const { t } = useTranslation();

  const deleteMutation = useMutation(
    async () => {
      await deleteObjectiveKPI({
        kpiId: kpi.objectiveKPIId,
        objectiveId: objective.id,
        ownerId: objective.owner[0].id,
        ownerType: objective.owner[0].type
      });
    },
    {
      onSuccess: onSubmitSuccess
    }
  );

  return (
    <div>
      <Typography>
        {t('objective.kpi.deleteConfirmation')}
      </Typography>
      <Typography>
        <b>{kpi.name}</b>
      </Typography>
      <DialogActions style={ { marginTop: 8 } }>
        <Button onClick={ deleteMutation.mutate } color='primary' variant='contained'>
          { t('objective.dialog.save') }
        </Button>
        <Button onClick={ onCancel } color='primary'>
          { t('objective.dialog.cancel') }
        </Button>
      </DialogActions>
    </div>
  );
};

export default DeleteKPI;
